<template>
  <div>
<!--    <selectershoufang
      :items="districts"
      :zujin="zujin"
      :huxing="huxing"
      :mianji="mianji"
      @change="getFilter"
    ></selectershoufang> -->
    <div class="houselist">
      <van-search v-model="k" placeholder="请输入搜索关键词" @search="search" />
      <ul>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="true"
        >
          <li
            v-for="(item, index) in lists"
            :key="index"
            @click="$router.push('/ershoufang/view/' + item.id)"
          >
            <div class="img">
              <div class="top" v-if="item.stick"></div>
              <img :src="item.thumbnail" />
            </div>
            <div class="info">
              <h1>
                {{ item.title }}
                {{ item.price ? item.price + item.unit : "面议" }}
              </h1>
              <p class="tag">
                <van-tag color="#f74c31" text-color="#fff" 
                  >必看好房</van-tag
                >
              </p>
              <div class="pflex">
                <p class="txt2">
                  {{ item.shi }}{{ item.ting }} | {{ item.community }}
                </p>
                <p class="txt1">
                  {{ item.price ? item.price : "面议" }}
                  <small v-if="item.price">{{ item.unit }}</small>
                </p>
              </div>
            </div>
          </li>
        </van-list>
      </ul>
    </div>
    <footbar />
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;
import Selectree from "../commpents/selectree";
import Selectershoufang from "../commpents/selectershoufang";
import Footbar from "../commpents/footbar";
import { Toast, DropdownMenu, DropdownItem, TreeSelect, Tag, List,Search } from "vant";

export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [TreeSelect.name]: TreeSelect,
    [Tag.name]: Tag,
    [List.name]: List,
        [Search.name]: Search,
    Selectree,
    Selectershoufang,
    Footbar,
  },

  data() {
    return {
      getInitUrl: root + "ershoufang/init",
      getDataUrl: root + "ershoufang/person",
      value: 0,
      page: 1,
      lists: [],
      districts: [],
      filter: {},
      zujin: [],
      huxing: [],
      mianji: [],
      total: 0,
      loading: false,
      finished: false,
      id: 0,
      k: "",
    };
  },
  watch: {
    $route(to, from) {
      this.lists=[];
      this.filter.page = 1;
      this.filter.total = 0;
      this.filter.id= this.$route.params.id;
      this.getData();
    },
  },
  mounted() {
    this.filter.page = this.page;
    this.filter.id = this.$route.params.id;
   
  },

  methods: {
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: self.filter,
        headers: self.getRequestHeader(),
        success: function (reponseData, status) {
          self.districts = reponseData.data.district;
          self.districts.push({
            id: 0,
            text: "不限",
          });
          self.zujin = reponseData.data.filter.zujin;
          self.huxing = reponseData.data.filter.huxing;
          self.mianji = reponseData.data.filter.mianji;
          self.Share();
        },
        error: function () {
          self.$toast("system error");
        },
      });
    },
    getData() {
      var self = this;
      $.ajax({
        url: self.getDataUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: self.filter,
        headers: self.getRequestHeader(),
        success: function (reponseData, status) {
          var lists = reponseData.data.lists;
          self.loading = false;
          self.total = reponseData.data.total;

          for (var i in lists) {
            self.lists.push(lists[i]);
          }
          self.page++;
        },
        error: function () {
          self.$toast("system error");
        },
      });
    },
    search(value) {
      if (value == "") {
        this.$toast("关键词为空");
        return;
      }
      this.filter.k = value;
      this.lists = [];
      this.page = 1;
      this.filter.page = this.page;
      this.getData();
    },
    getFilter(value) {
      console.log(value);
      this.lists = [];
      this.page = 1;
      this.filter = value;
      this.filter.page = this.page;
      this.getData();
    },
    onLoad() {
      this.filter.page = this.page;
      this.loading = true;
      this.getData();

      if (this.total == 0) {
        return;
      }
      if (this.page >= this.total) {
        this.finished = true;
      }
    },
    Share() {
      var title = "石柱房产网-买房.卖房.租房-找石柱生活网帮忙！";
      var description =
        "提供石柱县新楼盘、二手房、租房、商铺；房屋买卖，找石柱生活网房小柒帮忙！";
      var avatar = "http://fc.45win.com/house/web/images/logo.png";
      var url = window.location.href;
      this.setShare(title, description, url, avatar);
    },
  },
};
</script>

<style scoped>
</style>>



